import type { Document } from '@onefootprint/request-types/dashboard';

// The identifier and version of the first upload is unique to a document
const getDocumentId = (document: Document): string => {
  const identifyingUpload = document.uploads[0];
  const id = `${identifyingUpload.identifier}:${identifyingUpload.version}`;
  return id ?? '';
};

export default getDocumentId;
